"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuidOrGenerate = void 0;
const uuid_1 = require("uuid");
/**
 * Return a GUID string if a valid one or generate
 * a random one if its a falsey.
 *
 * @param guid
 * @returns
 */
const getGuidOrGenerate = (guid) => {
    return typeof guid === 'string' && guid.length > 0 ? guid : (0, uuid_1.v4)().replace(/-/g, '');
};
exports.getGuidOrGenerate = getGuidOrGenerate;
exports.default = exports.getGuidOrGenerate;
//# sourceMappingURL=getGuidOrGenerate.js.map